import { DB } from 'src/app/model/subscription';
import { SubscriptionDatabase } from 'src/app/model/subscriptionDatabase';
import { DatabaseCredentials } from 'src/app/authentication/credentials';
import { ImpExpTreeNode } from 'src/app/portal/account-console-test/import-export-management/check-list-database';

// ================================================================================
export class ExtendedSubscriptionDatabase {
    AdminCredentials: DatabaseCredentials;
    Database: SubscriptionDatabase;
    AccountName: string;
    Country: string;
    Collation: string;
    DB: DB.unknown;

    ImportDefaultData = false;
    ImportSampleData = false;
    ImportIsoCountry = '';
    ImportConfiguration = '';

    // ------------------------------------------------------------------------------
    constructor(credentials: DatabaseCredentials, subDatabase: SubscriptionDatabase) {
        this.AdminCredentials = credentials;
        this.Database = subDatabase;
        this.Country = '';
        this.Collation = '';
        this.AccountName = '';
    }
}

// ================================================================================
export class SubscriptionFullInfo {
    SubDatabase: SubscriptionDatabase;
    SubscriptionDescription: string;
    InstanceValidateStatus: number;

    // ------------------------------------------------------------------------------
    constructor(subscriptionDescri: string, subDatabase: SubscriptionDatabase, status: number) {
        this.SubscriptionDescription = subscriptionDescri;
        this.SubDatabase = subDatabase;
        this.InstanceValidateStatus = status;
    }
}

// Classi per passaggio parametri al back-end per l'importazione dati di default/esempio
// ================================================================================
export class ImportDataBodyContent {
    Database: SubscriptionDatabase;
    ImportParameters: ImportDataParameters;
    AccountName = '';
    Country = '';
    Edition = '';
    ConfigurationType = ''; // default/sample/custom
    Configuration = ''; // Basic/Manufacturing/etc.
    ImportConfigurations: string[] = []; // not used in front-end
    ImportKey = ''; // redis key
    LoadFromDockerVolume = false;
    FormatType = ''; // formato esportazione file (xml / json)
    TaskId = 0;
	  ImportExportKey = '';
    Files: string[] = []; // lista path files da importare
}

// ================================================================================
export class ImportDataParameters {
    OverwriteRecord = true;
    DeleteTableContext = false;
    NoOptional = true;
}

// Classi per passaggio parametri al back-end per la cancellazione dei database
// Si compone di:
// - oggetto SubscriptionDatabase da eliminare
// - credenziali di amministrazione di SQL Azure (solo per questo tipo di provider e se voglio eliminare almeno un database)
// - parametri aggiuntivi relativi all'eliminazione dei contenitori
// ============================================================================
export class DeleteDatabaseBodyContent {
    Database: SubscriptionDatabase;
    AdminCredentials: DatabaseCredentials;
    DeleteParameters: DeleteDatabaseParameters;
}

// ============================================================================
export class DeleteDatabaseParameters {
    DeleteERPDatabase = false;
    DeleteDMSDatabase = false;
}

// Classe con la lista dei nomi dei database univoci da creare
// ============================================================================
export class SubscriptionDatabaseNames {
    MasterDatabase = '';
    MasterDatabaseDMS = '';
    TestDatabase = '';
    TestDatabaseDMS = '';
}

// THESE VALUES MUST BE SYNCHRONIZED WITH ENUM DBMSType
// in Standard\tbws-library\taskbuilder-netcore-interfaces\Enums.cs
// and Standard\tbws-library\taskbuilder-netcore-interfaces\Strings.cs - class NameSolverDatabaseStrings
// -----------------------------------------------------------------------------
export class DatabaseProvider {
    public static readonly SQLAZURE = 'SQLAzure';
    public static readonly SQLSERVER = 'SQLServer';
    public static readonly POSTGRES = 'Postgres';

    public static readonly Providers: Array<{ name: string; value: string }> = [
        // { name: 'SQL Azure', value: DatabaseProvider.SQLAZURE },
        { name: 'SQL Server', value: DatabaseProvider.SQLSERVER },
        { name: 'PostgreSQL', value: DatabaseProvider.POSTGRES },
    ];
}

// -----------------------------------------------------------------------------
export class ImportOptions {
    public static readonly NOIMPORT = 'NOIMPORT';
    public static readonly IMPORTDEFAULT = 'IMPORTDEFAULT';
    public static readonly IMPORTSAMPLE = 'IMPORTSAMPLE';
}

// -----------------------------------------------------------------------------
export class ImportExportConsts {
    public static readonly INTL = 'INTL';
    public static readonly BASIC = 'Basic';
    public static readonly DEFAULT = 'default';
    public static readonly SAMPLE = 'sample';
    public static readonly CUSTOM = 'custom';
}

// -----------------------------------------------------------------------------
export class DatabaseConsts {
    // suffixes for key column 'Name' in SubscriptionDatabases
    public static readonly SubDbNameApplicationSuffix = '_DB';
    public static readonly SubDbNameTestSuffix = '_TestDB';

    // dbowner is the same for all databases
    // lowercase because it is compliant with all provider database
    public static readonly DbOwnerName = 'tb4_owner';
    // La password è stata spostata nel backend per  questioni di sicurezza.
    // public static readonly DbOwnerPassword = "****";

    // suffixes for database container names
    public static readonly DbDataSuffix = '_Data';
    public static readonly DbDMSSuffix = '_DMS';
    public static readonly TestDbDataSuffix = '_TestData';
    public static readonly TestDbDMSSuffix = '_TestDMS';
}

// Classe per passaggio parametri al back-end per l'esportazione dati
// ================================================================================
export class ExportDataBodyContent {
    Database: SubscriptionDatabase;
    AccountName: string;
    FormatType: string; // formato esportazione file (xml / json)
    SaveInDockerVolume = false;
    Tables: ImpExpTreeNode[]= [];
    TaskId = 0;
    ImportExportKey = '';
}
